import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../../common/api/request';
import { SamplingPlanningData } from './types';

interface UpdateMutationOptions {
  onSuccess?: (data: SamplingPlanningData[]) => void;
  onError?: (error: any) => void;
}

export function useSamplingPlanningUpdate(options?: UpdateMutationOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SamplingPlanningData[]): Promise<SamplingPlanningData[]> => {
      const response = await axios.put('/sampling-planning', data);
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate and refetch sampling planning data
      queryClient.invalidateQueries({ queryKey: ['sampling-planning-data'] });
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
} 